


























import Vue from 'vue';
import StepContent from '@/components/StepContent.vue';
import BodyScars from '@/components/BodyScars.vue';
import BackgroundTools from '@/components/BackgroundTools.vue';

export default Vue.extend<any, any, any, any>({
	components: {
		BackgroundTools, BodyScars, StepContent,
	},
	data: () => ({
		stitches: false,
	}),
});
